import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IDepartmentState } from './department.types';
import { IDepartmentData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IDepartmentState = {
  version: 1,
  departments: [] as IDepartmentData[]
};

const namespaced = true;

export const department: Module<IDepartmentState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
